import React from 'react';
import { useWindowSize } from 'hooks/use-window-size';
import { bpMedium } from 'constants/breakpoints';
//import { ScrollTo } from 'components/scroll-to';
import styles from './style.module.scss';

export const SelectedEngine = ({
  selected,
  description,
  scrollTo,
  colourTempName,
}) => {
  /*
  const [colourTemp, setColourTemp] = useState({
    ...
  });

  const handleChange = (name, value) => {
    setState({
      ...state,
      [name]: value,
    });
  };
*/
  const { width } = useWindowSize();
  const isLarge = width >= bpMedium;
  /*
  const colourTemps = useSelector(
    (state) => state.product.activeEngine.specification_code.colour_temperature
  );
*/
  //const colourTempButtons = colourTemps.map((temp) => <p onClick={() => {handleChange('activeColourTemperature', temp.value)}}>{temp.label}</p>);

  const valueLabel = '';
  //'all values are for our ' + colourTempName + ' colour temp';

  return (
    <>
      {scrollTo && isLarge}
      <div className={styles.description}>
        <div>
          <span>
            <h2>{selected}</h2>
            <p>{valueLabel}</p>
          </span>
          <ul>
            {description.split(',').map((item, i) => {
              return <li key={i}>{item}</li>;
            })}
          </ul>
        </div>
      </div>
    </>
  );
};
